"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _radioButtons = require("@vds-core/radio-buttons");
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * @deprecated
   * If provided, the Radio will be rendered in the Selected State
   */
  checked: _propTypes["default"].bool
};
var defaultProps = {
  inverted: false
};
var _calculateLetterSpacing = function _calculateLetterSpacing() {
  return (0, _javascriptStyleHelpers.calculateRem)("0.5px");
};
var _calculateErrorBackgroundColor = function _calculateErrorBackgroundColor() {
  return "transparent";
};
var _calculateErrorForegroundColor = function _calculateErrorForegroundColor() {
  return "#ed7000";
};
var _calculateDefaultBorderColor = function _calculateDefaultBorderColor(selected, surface) {
  return surface === "dark" ? _theme.colors.white : _theme.colors.black;
};
var _calculateHoverBorderColor = function _calculateHoverBorderColor(calculateErrorForegroundColor, selected, error, surface) {
  if (error) {
    return calculateErrorForegroundColor(surface);
  }
  return surface === "dark" ? _theme.colors.white : _theme.colors.black;
};
var _calculateHoverBorderWidth = function _calculateHoverBorderWidth(selected, isMobileDevice) {
  return (0, _javascriptStyleHelpers.calculateRem)(1);
};
var RadioButton = function RadioButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_radioButtons.RadioButton, (0, _extends2["default"])({}, props, {
    surface: props.inverted ? "dark" : "light",
    selected: props.checked !== undefined ? props.checked : props.selected,
    calculateErrorBackgroundColor: _calculateErrorBackgroundColor,
    calculateErrorForegroundColor: _calculateErrorForegroundColor,
    calculateDefaultBorderColor: _calculateDefaultBorderColor,
    calculateHoverBorderColor: _calculateHoverBorderColor,
    heavyErrorBorder: true,
    calculateLetterSpacing: _calculateLetterSpacing,
    calculateHoverBorderWidth: _calculateHoverBorderWidth
  }));
};
RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;
var _default = exports["default"] = RadioButton;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/radio-buttons/dist/cjs/components/RadioButton.js
// module id = 586
// module chunks = 0